module.exports = __webpack_public_path__ + "img/promos-orange.06e40ea3.svg";